import { initializeApp } from "firebase/app";
import { initializeFirestore } from "firebase/firestore";
import {
  initializeAuth,
  browserLocalPersistence,
  indexedDBLocalPersistence,
  inMemoryPersistence,
} from "firebase/auth";

const firebaseConfig = {
  apiKey: "AIzaSyAkpIT1hSbvqjo0AEOY1Zs1PfAp9qP-1oQ",
  authDomain: "bekvam-delivery-system.firebaseapp.com",
  projectId: "bekvam-delivery-system",
  storageBucket: "bekvam-delivery-system.firebasestorage.app",
  messagingSenderId: "546543874996",
  appId: "1:546543874996:web:33d680125677dfa2ffb8e1"
};

const app = initializeApp(firebaseConfig);

// إعداد متين للاتصال:
// - بدون localCache الدائم (IndexedDB): التخزين متعدد التبويبات كان يسبّب تعارض أقفال على
//   Safari/iOS فتتعلّق القراءات للأبد (store=null → شاشة "تعذّر تحميل المتجر"). نستخدم الكاش
//   الافتراضي في الذاكرة فلا توجد أقفال بين التبويبات.
// - experimentalForceLongPolling: نفرض الـ long-polling دائماً بدل الاعتماد على الكشف
//   التلقائي (auto-detect). الكشف التلقائي يجرّب WebSocket أولاً وقد يتعلّق أول اتصال على
//   شبكات/متصفحات iOS/الجوال المتذبذبة فلا ترجع القراءة أبداً (store=null → شاشة «تعذّر
//   تحميل المتجر»، ويُصلَح فقط بريفرش). فرض long-polling أبطأ بقليل لكنه موثوق على كل شبكة.
export const db = initializeFirestore(app, {
  experimentalForceLongPolling: true,
});
// ⚠️ لا نصدّر `storage` هنا عمداً. هذا الملف يعيش في main.js (يستورده المتجر لأجل
// `db`)، فاستدعاء getStorage(app) وقت التحميل كان يجرّ SDK التخزين (~15KB مضغوطة)
// إلى أول تحميل **كل زائر متجر** — وهو لا يستعمله إطلاقاً: رفع صور المتجر يمرّ عبر
// R2 (action=r2-upload)، وتخزين Firebase حكرٌ على شاشات الأدمن.
// المستهلكون ينادون getStorage() محلياً (نفس ما يفعله MetaAdsComponents أصلاً)،
// فينتقل الـ SDK إلى شنكاتهم الكسولة بدل المسار الحرج.

// حفظ جلسة الدخول: localStorage أولاً، لا IndexedDB.
//
// `getAuth()` يرتّب التخزين افتراضياً IndexedDB ثم localStorage، فيفتح قاعدة
// `firebaseLocalStorageDb` لكل زائر — حتى زائر المتجر المجهول، لأن هذا الملف نفسه
// هو مصدر `db` الذي يستورده المتجر. و IndexedDB مكسور فعلياً على WebKit (سفاري/iOS
// ومتصفحات إنستغرام/فيسبوك المدمجة)، فكانت رفوض غير معالَجة تتسرّب من داخل SDK
// المصادقة وتُشكّل ~71% من أحداث Sentry الأسبوعية:
//   • InvalidStateError: Object store cannot be found in the database
//   • UnknownError: Attempt to get records from database without an in-progress transaction
//   • UnknownError: Failed to look up IDBObjectStoreInfo from identifier
// وهي نفس عائلة المشاكل التي فرضت التخلّي عن كاش Firestore الدائم أعلاه.
//
// localStorage يكفي هنا: الدخول بالإيميل/التوكن المخصّص فقط (لا popup/redirect)،
// ومزامنة التبويبات تتم عبر حدث `storage` بلا أقفال. نُبقي IndexedDB كبديل ثانٍ
// لو تعذّر localStorage، و inMemory كملاذ أخير كي لا ينهار الإقلاع في سياق
// يمنع كل أنواع التخزين (تصفّح خاص متشدّد) — أسوأ حالة: جلسة لا تدوم بعد إغلاق
// التبويب، بدل شاشة معطّلة. و SDK يبحث في كل الطبقات المتاحة عن جلسة محفوظة
// وينقلها للطبقة المختارة، فلا يخرج أحد من حسابه بسبب هذا التغيير.
//
// مكسب إضافي: `getAuth()` يسحب معه `browserPopupRedirectResolver` ونحن لا نستخدمه،
// فالتصريح المباشر أنزل main.js من 612,847 إلى 600,634 بايت (‎−12KB‎ من أول تحميل).
export const auth = initializeAuth(app, {
  persistence: [browserLocalPersistence, indexedDBLocalPersistence, inMemoryPersistence],
});
